import {EntityService} from '../../../service/EntityService';

export class CustomerService extends EntityService {
  static entity = 'iam-party/customers';

  static approve(id: string): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/approve`).then(res => res.data);
  }
}